import React from "react";

import Tags from "./TagsSidebar/TagsSidebar";

export default function TagsPage(props) {
	return <Tags />;
}
